// Single source of truth for the backend API base URL.
//
// Shape: https://{REACT_APP_domain}/api/{REACT_APP_City}/{lang}/{cityId}
//   - lang:   current UI language code ("en" | "ar")
//   - cityId: selected city within the tenant; defaults to "0"
//
// Centralizing this means a change to the URL shape, the host, or the
// cityId handling is made once here instead of being duplicated across
// App.js, the data hooks, and every page that fetches.

// The tenant's selected city id. Defaults to "0" (the tenant-wide feed)
// when no city has been chosen.
export const getCityId = () => localStorage.getItem("cityId") || "0";

// Build the API base URL for the given language. `lang` falls back to the
// stored UI language so callers without a translation function still work.
export const getApiBaseUrl = (lang = localStorage.getItem("lang") || "en") =>
  `https://${process.env.REACT_APP_domain}/api/${process.env.REACT_APP_City}/${lang}/${getCityId()}`;
